export const ja = {
    'nav.today': "本日の概要",
    'nav.calendar': "需要カレンダー",
    'nav.rates': "料金とルール",
    'nav.automation': "自動化センター",
    'nav.audit': "監査ログ",
    'nav.settings': "設定",
    'sidebar.status': "接続済み",
    'stat.occupancy': "稼働率",
    'stat.adr': "平均客室単価 (ADR)",
    'stat.revpar': "RevPAR",
    'stat.revenue': "推定収益",
    'stat.trend.vsLastWeek': "対先週比",
    'stat.trend.onPace': "順調",
    'dashboard.actions.title': "推奨アクション",
    'dashboard.actions.empty': "アクションが見つかりません。",
    'filter.all': "すべて",
    'filter.pricing': "価格設定",
    'filter.restriction': "制限",
    'action.approve': "承認して適用",
    'action.reject': "拒否",
    'action.risk.low': "低リスク",
    'action.risk.medium': "中リスク",
    'action.risk.high': "高リスク",
    'action.label.current': "現在",
    'action.label.proposed': "提案",
    'action.metric.impact': "影響",
    'action.metric.why': "理由",
    'action.status.executed': "自動実行済み",
    'header.search': "検索...",
    'header.logout': "ログアウト",
    'auto.level.title': "自動操縦レベル",
    'auto.level.manual': "手動",
    'auto.level.manual.desc': "すべての推奨事項を個別に承認します。",
    'auto.level.assisted': "アシスト",
    'auto.level.assisted.desc': "低リスクを自動承認。大きな変更を確認します。",
    'auto.level.auto': "完全自動",
    'auto.level.auto.desc': "AIが制限内で24時間365日価格を管理します。",
    'auto.level.active': "アクティブ",
    'auto.guardrails.title': "安全ガードレール",
    'auto.guardrails.maxIncrease': "1日あたりの最大値上げ",
    'auto.guardrails.maxIncrease.desc': "価格ショックを防ぎます。",
    'auto.guardrails.maxDecrease': "1日あたりの最大値下げ",
    'auto.guardrails.maxDecrease.desc': "不当な安売りを防ぎます。",
    'auto.guardrails.minRate': "最低価格",
    'auto.guardrails.minRate.desc': "これ以下の価格では販売しません（純額）。",
    'auto.emergency.title': "緊急制御",
    'auto.emergency.label': "緊急停止",
    'auto.emergency.desc': "すべての自動化を直ちに停止します。",
    'auto.emergency.btn': "システム一時停止",
    'rates.filter.all': "すべての部屋タイプ",
    'rates.filter.next14': "今後14日間",
    'rates.export': "エクスポート",
    'audit.table.time': "時間",
    'audit.table.actor': "実行者",
    'audit.table.category': "カテゴリ",
    'audit.table.action': "アクション",
    'audit.table.details': "詳細",
    'audit.table.status': "ステータス",
    'settings.pms.title': "PMS接続",
    'settings.pms.connected': "接続先",
    'settings.pms.disconnect': "切断",
    'settings.account.title': "アカウント",
    'settings.account.role': "役割",
    'settings.restart': "オンボーディングを再開",
    'onboard.title': "PMSを接続",
    'onboard.desc': "在庫同期のためにPMSを選択してください。",
    'onboard.connecting': "接続中...",
    'onboard.connect': "接続",
    'onboard.success.title': "セットアップ完了！",
    'onboard.success.desc': "**SynthHotel Berlin** が同期されました。",
    'onboard.success.sub': "客室タイプ3種、料金プラン14種、予約243件をインポートしました。",
    'onboard.btn.dashboard': "ダッシュボードへ",
    'action.dynamic.weekend.title': "週末料金の値上げ",
    'action.dynamic.weekend.desc': "土曜の稼働率75%超、需要好調（24時間で+12室）。",
    'action.dynamic.minstay.title': "2泊以上の最低滞在を有効化",
    'action.dynamic.minstay.desc': "テイラー・スウィフトのコンサート発表。1泊の滞在を制限。",
    'action.dynamic.distress.title': "料金値下げ（需要低迷）",
    'action.dynamic.distress.desc': "来週火曜の稼働率35%。競合他社が€10値下げ。",
    'action.dynamic.gap.title': "空室充填：CTA削除",
    'action.dynamic.gap.desc': "1泊の空きあり。「到着不可」を削除して販売。",
};
